// @ts-nocheck
import { Close } from "@mui/icons-material";
import { Box, IconButton, Stack, useMediaQuery } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import routes from "../../routes/navRoutes";
import Logo from "../Logo/Logo";
import AccountButton from "./Footer/SidenavAccountButton";
import LogoutButton from "./Footer/SidenavLogoutButton";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import SidenavNetworks from "./Footer/SidenavNetworks";
import SidenavDrawer from "./SidenavDrawer";
import SidenavItem from "./SidenavItem";
import { useAuth } from "../../providers/AuthProvider";
import { PlaceChip } from "../Inputs/Chips/PlaceChip";
import { isAdmin } from "../../utils/helpers";
import LaunchCampaignReminder from "../Reminders/LaunchCampaignReminder";
import { useSidenav } from "../../providers/SidenavProvider";

export default function Sidenav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isMobile = useMediaQuery("(max-width:600px)");
  const { open, toggleDrawer } = useSidenav();

  return (
    <>
      <SidenavDrawer open={open}>
        <Stack alignItems={"space-between"} height={"100%"} p={2}>
          {/* SIDENAV HEADER */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ bgcolor: "white", p: 1 }}
          >
            <Logo />
            <IconButton
              aria-label="Close menu"
              onClick={toggleDrawer}
              sx={{
                display: { xs: "flex", sm: "none" },
                bgcolor: "primary.light",
                borderRadius: "8px",
                p: 1,
                "&:hover": {
                  bgcolor: "primary.light",
                },
              }}
            >
              <Close sx={{ color: "#000" }} />
            </IconButton>
          </Stack>

          {/* PlaceChip uniquement sur desktop - sur mobile c'est dans le header */}
          {!isMobile && <PlaceChip mt={1} mb={2} />}

          {/* SIDENAV BODY */}
          <Stack sx={{ boxSizing: "border-box" }} gap={0.5}>
            {routes.map((route, index) => {
              if (!isAdmin(user) && route?.hide?.(user)) return null;
              const active =
                pathname === route.path || (pathname.startsWith(route.path) && route.path !== "/");
              return (
                <SidenavItem
                  key={index}
                  route={route}
                  active={active}
                  handleToggle={toggleDrawer}
                />
              );
            })}
          </Stack>

          <Box sx={{ flexGrow: 1 }} />

          <LaunchCampaignReminder />

          {/* SIDENAV FOOTER */}
          <Stack mb={2}>
            <AccountButton handleToggle={toggleDrawer} />
            <LogoutButton />
            <Box mt={1} display="flex" justifyContent="flex-start">
              <LanguageSelector align="left" />
            </Box>
          </Stack>
          {/* NETWORKS IF MOBILE */}
          {isMobile && <SidenavNetworks />}
        </Stack>
      </SidenavDrawer>
    </>
  );
}
